import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment as env } from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class CampaignService {


  constructor(private http :HttpClient) { }


  Get(data:any) {
    return this.http.post(
      `${env.Server_URL}/Campaign/GetAllPaged`,data
    ) as Observable<any>;
  }
  Post(CampaignData: FormData): Observable<any> {
    return this.http.post<any>(
      `${env.Server_URL}/Campaign/Create`,
      CampaignData
    );
  }
  GetCampaignById(id) {
    return this.http.get(
      `${env.Server_URL}/Campaign/GetById?Id=${id}`
    ) as Observable<any>;
  }
  put(CampaignData: FormData): Observable<any> {
    return this.http.post<any>(
      `${env.Server_URL}/Campaign/Update`,
      CampaignData
    );
  }
  Delete(id: number): Observable<any> {
    return this.http.get<any>(
      `${env.Server_URL}/Campaign/Delete?id=${id}`
    );
    // change detete
  }
  
}
